import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forYou = ['You are currently teaching ESL/EFL or training to become a teacher', 'You want to teach with more structure, confidence and clarity', 'You are looking for a ready-to-use system, not more content to process', 'You want to improve your lessons without spending hours creating new resources', 'You teach in-person, online or both', 'You want your lessons to feel more organized, polished, and professional'];
const notForYou = ['You are looking for a video course or academic certification', 'You expect someone to script every single thing you say in class', 'You prefer creating every lesson entirely from scratch', 'You are not looking to change or expand your current teaching approach'];
export function AudienceSection() {
  return <section className="w-full bg-navy px-5 py-12 sm:py-20" data-id="element-21" data-mp="3hpwwc0b7f756">
      <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-2" data-id="element-22" data-mp="3hoc1saow3o7b">
        <AudienceCard title="✅ This system is for you if..." items={forYou} kind="positive" data-id="element-23" data-mp="14b2etozdpz0c" />
        <AudienceCard title="❌ This system is NOT for you if..." items={notForYou} kind="negative" data-id="element-24" data-mp="zbg0fc7tecpy" />
      </div>
    </section>;
}
function AudienceCard({
  title,
  items,
  kind
}: {
  title: string;
  items: string[];
  kind: 'positive' | 'negative';
}) {
  const positive = kind === 'positive';
  const Icon = positive ? CheckIcon : XIcon;
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.3,
    delay: positive ? 0 : 0.08,
    ease: [0.23, 1, 0.32, 1]
  }} className={`rounded-2xl border p-6 sm:p-8 ${positive ? 'border-gold/40 bg-navy-mid' : 'border-red-400/45 bg-maroon'}`} data-id="element-25" data-mp="gkosmf3h6udo">
      <h2 className={`mb-6 text-lg font-bold sm:text-xl ${positive ? 'text-gold' : 'text-white'}`} data-id="element-26" data-mp="21ykuljrgk1du">
        {title}
      </h2>
      <ul className="space-y-4" data-id="element-27" data-mp="3vh1ncn5j679f">
        {items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-28" data-mp="42m8h172his5">
            <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-gold/15 text-gold' : 'bg-red-500/20 text-red-300'}`} data-id="element-29" data-mp="4470ok5wspmu">
              <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-30" data-mp="3qful13m5q0a5" />
            </span>
            <span className="text-sm leading-relaxed text-white/85" data-id="element-31" data-mp="i0ars4lhkhv3">{item}</span>
          </li>)}
      </ul>
    </motion.div>;
}